import React, { useCallback, useEffect, useState } from 'react';

import Track from '../Operate/Track';
import Banner from './Details/Banner';
import Info from './Details/Info';
import classNames from 'classnames';
import GoogleMint from '../Operate/GoogleMint';
import Report from '../Operate/Report';
import ShowMore from './ShowMore';
import { useAppSelector } from 'store/hooks';
import ShowMoreIcon from './ShowMore/ShowMoreIcon';
import {
  ActiveRaffle,
  ProjectWhitelist,
  getProjectDetail,
} from 'api/project/project_detail';

interface ICardPProps {
  isChangeStyle?: boolean;
  id: number;
  banner: string;
  logo: string;
  blockchain: string;
  twitter: string | undefined;
  dcInviteLink: string | undefined;
  website: string | undefined;
  trackAmount: number;
  isTracked: boolean;
  name: string | undefined;
  isRecommend: boolean;
  mintDate: number | undefined;
  mintTime: string;
  supplyCount: number | undefined;
  whitelistPrice: number | undefined | string;
  publicPrice: number | undefined | string;
  whitelistCount?: number | undefined;
  raffleCount?: number | undefined;
  hasWon?: boolean;
  project: any;
  isOpenMore: boolean;
}

const CardP: React.FC<ICardPProps> = ({
  isChangeStyle,
  id,
  banner,
  logo,
  blockchain,
  twitter,
  dcInviteLink,
  website,
  trackAmount,
  isTracked,
  name,
  isRecommend,
  mintDate,
  mintTime,
  supplyCount,
  whitelistPrice,
  publicPrice,
  whitelistCount,
  raffleCount,
  hasWon,
  project,
  isOpenMore,
}) => {
  const { curExpandProject } = useAppSelector((state) => state.projectDetail);
  const [openShowMore, setOpenShowMore] = useState(isOpenMore);

  const [projectWhitelist, setProjectWhitelist] = useState<ProjectWhitelist[]>(
    []
  );
  const [projectActiveRaffle, setProjectActiveRaffle] = useState<
    ActiveRaffle[]
  >([]);
  const [requested, setRequested] = useState(false);

  const getProjectWhitelistRaffle = useCallback(
    async (isUpdate?: boolean) => {
      if (!requested && !isUpdate) {
        const res = await getProjectDetail(id);
        setRequested(true);
        setProjectWhitelist(res?.project_whitelist);
        setProjectActiveRaffle(res?.active_raffles);
      } else if (isUpdate) {
        const res = await getProjectDetail(id);
        setProjectWhitelist(res?.project_whitelist);
      }
    },
    [id, requested]
  );

  useEffect(() => {
    if (isOpenMore) {
      getProjectWhitelistRaffle();
    }
  }, [getProjectWhitelistRaffle, isOpenMore]);

  const toggleOpenShowMore = useCallback((open: boolean) => {
    setOpenShowMore(open);
  }, []);

  return (
    <div
      className={classNames('', {
        'w-full': !isChangeStyle,
        'w-[360px] bg-neutral-1000 md:w-[380px]': isChangeStyle,
      })}
    >
      <div
        className={classNames(
          'w-full rounded-2xl   border-neutral-700 px-3 py-6 ',
          {
            ' border lg:flex lg:justify-between lg:gap-5': !isChangeStyle,
            ' rounded-b-none border-4 border-b-0':
              isChangeStyle && openShowMore && curExpandProject === id,
            'hover:border-neutral-500':
              (!openShowMore || curExpandProject !== id) && !isChangeStyle,
            'border-4 ':
              isChangeStyle && (!openShowMore || curExpandProject !== id),
          }
        )}
      >
        <div
          className={classNames('flex w-full flex-col gap-5', {
            'md:flex-row': !isChangeStyle,
          })}
        >
          <div
            className={classNames(
              'flex items-center justify-between gap-[10px]',
              {
                'md:justify-start': !isChangeStyle,
              }
            )}
          >
            <Track
              id={id}
              mintDate={mintDate}
              isTracked={isTracked}
              largeIcon={true}
              trackAmount={trackAmount}
            />
            <Banner
              isChangeStyle={isChangeStyle}
              isRecommend={isRecommend}
              banner={banner}
              logo={logo}
              blockchain={blockchain}
              twitter={twitter}
              dcInviteLink={dcInviteLink}
              website={website}
              mintDate={mintDate}
              mintTime={mintTime}
              hasWon={hasWon}
            />
          </div>
          <Info
            name={name}
            isRecommend={isRecommend}
            mintDate={mintDate}
            mintTime={mintTime}
            supplyCount={supplyCount}
            whitelistPrice={whitelistPrice}
            publicPrice={publicPrice}
            whitelistCount={whitelistCount}
            raffleCount={raffleCount}
            blockchain={blockchain}
            isChangeStyle={isChangeStyle}
          />
        </div>
        <div
          className={classNames(
            'mt-5 flex items-center justify-center gap-4 ',
            {
              'lg:mt-0 lg:justify-end': !isChangeStyle,
            }
          )}
        >
          <GoogleMint
            date={mintDate as any}
            time={mintTime}
            name={encodeURIComponent(name as string) || ''}
            blockchain={blockchain}
            publicPrice={publicPrice as any}
            largeIcon={true}
            supply={supplyCount || 0}
            website={website as string}
            wl={whitelistPrice as any}
            project={project}
          />
          <Report project={project} largeIcon={true} />
          <ShowMoreIcon
            id={id}
            openShowMore={openShowMore}
            toggleOpenShowMore={toggleOpenShowMore}
            getProjectWhitelistRaffle={getProjectWhitelistRaffle}
          />
        </div>
      </div>
      <ShowMore
        id={id}
        isChangeStyle={isChangeStyle}
        openShowMore={openShowMore}
        getProjectWhitelistRaffle={getProjectWhitelistRaffle}
        projectWhitelist={projectWhitelist}
        projectActiveRaffle={projectActiveRaffle}
        requested={requested}
      />
    </div>
  );
};

export default CardP;
